import { useStoreEnvSettings } from '@/shared/store/environment'

const SKIP_AUTO_LOGIN_ONCE_KEY = 'skipAutoLoginOnce'

export const useKerberosAutoLoginGuard = () => {
  const envSettingsStore = useStoreEnvSettings()
  const isKerberosEnabled = () => envSettingsStore.getSettingByKey<boolean>('isKerberosEnabled')?.value === true

  const markSkipNextKerberosAutoLogin = () => {
    if (!isKerberosEnabled()) return
    sessionStorage.setItem(SKIP_AUTO_LOGIN_ONCE_KEY, '1')
  }

  const consumeShouldSkipKerberosAutoLogin = () => {
    if (!isKerberosEnabled()) return false
    const shouldSkip = sessionStorage.getItem(SKIP_AUTO_LOGIN_ONCE_KEY) === '1'

    if (shouldSkip) {
      sessionStorage.removeItem(SKIP_AUTO_LOGIN_ONCE_KEY)
    }

    return shouldSkip
  }

  return {
    markSkipNextKerberosAutoLogin,
    consumeShouldSkipKerberosAutoLogin,
  }
}
